import { useEffect, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { RouteType } from "./enums/RouteType";
import useShallowSelector from "./hooks/useShalowSelector";
import { confirmUserRequest, setRedirectUrl } from "./store/auth/actionCreators";
import { selectAuth } from "./store/auth/selectors";

import AnimationApp from "./pages/AnimationApp/AnimationApp";
import useCookies from "./hooks/useCookies";

function App() {
    const dispatch = useDispatch();
    const { getTokens } = useCookies();
    const auth = useShallowSelector(selectAuth);
    const isConfirm = window.location.pathname === RouteType.CONFIRM;

    useLayoutEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const redirectUrl = queryParams.get("redirect_uri");
        const isOAuth = queryParams.get("method") === "OAuth";
        const cookies = getTokens();

        if (cookies.accessToken && cookies.refreshToken && redirectUrl && !isOAuth) {
            const urlWithTokens = new URL(redirectUrl);
            urlWithTokens.searchParams.set("access_token", cookies.accessToken);
            urlWithTokens.searchParams.set("refresh_token", cookies.refreshToken);
            window.location.replace(urlWithTokens.toString());
            return;
        }

        const redirectUrlQueries = window.location.search;
        if (redirectUrl) {
            dispatch(setRedirectUrl({ redirectUrl, redirectUrlQueries, isOAuth: isOAuth }));
        }
    }, [dispatch, getTokens]);

    useEffect(() => {
        const { redirectUrl, redirectUrlQueries, token: authToken, isOAuth } = auth;
        const cookies = getTokens();
        const token = cookies.accessToken || authToken;

        if (redirectUrl && token && !isOAuth) {
            const originalParams = new URLSearchParams(redirectUrlQueries || "");
            let state = originalParams.get("state");
            const responseType = originalParams.get("response_type") || "";

            if (originalParams.has("state")) {
                state = originalParams.get("state");
            }

            let finalUrl = `${redirectUrl}/?${encodeURIComponent(responseType)}=${encodeURIComponent(token)}`;
            if (state) {
                finalUrl += `&state=${encodeURIComponent(state)}`;
            }
            window.location.href = finalUrl.toString();
        }
    }, [auth.redirectUrl, auth.redirectUrlQueries, auth.token, getTokens, auth]);

    useEffect(() => {
        if (isConfirm) {
            const searchParams = new URLSearchParams(window.location.search);
            const code = searchParams.get("code");
            if (code !== null) {
                dispatch(confirmUserRequest({ code }));
            }
        }
    }, [isConfirm, dispatch]);

    if (auth === null) return null;

    return <AnimationApp />;
}

export default App;
